export const memberQueryKey = (slug) => ["MEMBER", slug];
export const memberQueryOptions = (slug) => ({
    queryKey: memberQueryKey(slug),
    queryFn: async () => {
        const response = await fetch(`/api/members/${slug}`);
        if (!response.ok) {
            throw new Error(`Failed to load member ${slug}`);
        }
        return response.json();
    },
    staleTime: 5 * 60 * 1000,
});
